import { CONFIG_LAZY_REDUCERS } from "actions/constants.js";

import projectConfig from "config/projectConfig.js";
import { emailHasExtension } from "lib/helpers/helpers.js";

export const configProject = (futureProject) => {
	return (dispatch, getState) => {
		let { currentProject, userEmail } = getState().login;
		const projectConfigReducer = getState().projectConfig;
		const darkUI = projectConfigReducer ? projectConfigReducer.darkUI : true;

		currentProject = futureProject || currentProject;

		const config = projectConfig[currentProject];

		if (config) {
			dispatch({
				type: "configProject",
				// config
				availableTabs: config.availableTabs,
				additionalLegendHeaders: config.additionalLegendHeaders,
				aiToggle: config.aiToggle,
				aiToggleNoReaction: config.aiToggleNoReaction,
				altProjectForCrosstabsNarratives: config.altProjectForCrosstabsNarratives,
				alwaysShowContentInteractions: config.alwaysShowContentInteractions,
				analystSystem: config.analystSystem,
				chatConfig: config.chatConfig || null,
				documentChatConfig: config.documentChatConfig || null,
				compareHeaderConfig: config.compareHeaderConfig,
				compareMultiSelect: config.compareMultiSelect,
				configureStats: config.configureStats,
				contentColumns: config.contentColumns,
				contentHeaderSortAudienceDefault: config.contentHeaderSortAudienceDefault,
				contentHeaderSortSourceDefault: config.contentHeaderSortSourceDefault,
				contentTabCsvHeaders: config.contentTabCsvHeaders,
				contentTabDateBegin: config.contentTabDateBegin,
				contentTabDateEnd: config.contentTabDateEnd,
				contentTabTableHeaders: config.contentTabTableHeaders,
				contentTabMap: config.contentTabMap,
				dmaMap: config.dmaMap,
				// If the new project allows the UI theme toggle, then keep the current theme, otherwise use the new project's default
				darkUI: config.uiThemeToggle ? darkUI : !config.defaultLightUI,
				dataCatalogSupport: config.dataCatalogSupport || false,
				defaultAggregationLevel: config.defaultAggregationLevel || "timeseries",
				defaultEntityType: config.defaultEntityType,
				defaultLightUI: config.defaultLightUI,
				defaultSearchTranslationEnabled: config.defaultSearchTranslationEnabled,
				defaultSearchTranslationLanguages: config.defaultSearchTranslationLanguages,
				defaultZoom: config.defaultZoom,
				desiredCrosstabsNarrativeOrder: config.desiredCrosstabsNarrativeOrder,
				disableFilters: config.disableFilters,
				disableFiltersMessage: config.disableFiltersMessage,
				disableGeneralDownload: config.disableGeneralDownload,
				duplicateToggle: config.duplicateToggle,
				emailSubscribeOption: config.emailSubscribeOption,
				entityFiltersAvailable: config.entityFiltersAvailable,
				crosstabsBargraphTopLeft: config.crosstabsBargraphTopLeft,
				crosstabsBargraphMiddleTopLeft: config.crosstabsBargraphMiddleTopLeft,
				crosstabsBargraphMiddleLeft: config.crosstabsBargraphMiddleLeft,
				crosstabsBargraphMiddleBottomLeft: config.crosstabsBargraphMiddleBottomLeft,
				crosstabsBargraphBottomLeft: config.crosstabsBargraphBottomLeft,
				crosstabsBargraphTopRight: config.crosstabsBargraphTopRight,
				crosstabsBargraphMiddleRight: config.crosstabsBargraphMiddleRight,
				crosstabsBargraphBottomRight: config.crosstabsBargraphBottomRight,
				crosstabsNarrativeFacets: config.crosstabsNarrativeFacets,
				crosstabsNarrativeHeaderLabels: config.crosstabsNarrativeHeaderLabels,
				crosstabsNarrativeHeaders: config.crosstabsNarrativeHeaders,
				entityLanguage: config.entityLanguage,
				eventColumns: config.eventColumns,
				exoveraEditButton: config.exoveraEditButton && emailHasExtension({ email: userEmail, extension: "exovera.com" }),
				expandedContentShowTweets: config.expandedContentShowTweets,
				fakeSingleArticle: config.fakeSingleArticle,
				forceCrosstabsEntity: config.forceCrosstabsEntity,
				gaMeasurementId: config.gaMeasurementId,
				graphAudienceTooltipText: config.graphAudienceTooltipText,
				graphDataTypes: config.graphDataTypes,
				graphEventTooltipText: config.graphEventTooltipText,
				graphSourceTooltipText: config.graphSourceTooltipText,
				graphSpendingTooltipText: config.graphSpendingTooltipText,
				graphTabFacets: config.graphTabFacets,
				graphTabSelectorColumns: config.graphTabSelectorColumns,
				hideArticlesExport: config.hideArticlesExport,
				hideEntities: config.hideEntities,
				hideEntitiesInAIMode: config.hideEntitiesInAIMode,
				hideParentNarrativeTags: config.hideParentNarrativeTags,
				hideMap: config.hideMap,
				hideMapFilterIds: config.hideMapFilterIds,
				hideMapIndicatorInGraph: config.hideMapIndicatorInGraph,
				hideShare: config.hideShare,
				highlightedEntitiesTitle: config.highlightedEntitiesTitle,
				hotArticleLimit: config.hotArticleLimit,
				logRocketAppId: config.logRocketAppId || undefined,
				mapCountryIds: config.mapCountryIds || [],
				mapLookup: config.mapLookup,
				mapSourceTooltipText: config.mapSourceTooltipText,
				mapAudienceTooltipText: config.mapAudienceTooltipText,
				mapEventTooltipText: config.mapEventTooltipText,
				mapSpendingTooltipText: config.mapSpendingTooltipText,
				mediaEntityFilters: config.mediaEntityFilters,
				userSearchHideLocation: config.userSearchHideLocation,
				mediaLanguages: config.mediaLanguages,
				googleTranslateLanguages: config.googleTranslateLanguages,
				mediaCountries: config.mediaCountries,
				mediaPredictiveSelect: config.mediaPredictiveSelect,
				mediaSearchHeaders: config.mediaSearchHeaders,
				mediaTranslateTitles: config.mediaTranslateTitles,
				methodologyLink: config.methodologyLink,
				moeGraphAvailable: config.moeGraph,
				moeMapAvailable: config.moeMap,
				moeTabName: config.moeTabName,
				multiDocumentChatConfig: config.multiDocumentChatConfig || null,
				narrativeEntityTranslateToggle: config.narrativeEntityTranslateToggle,
				noUserSearches: config.noUserSearches,
				percentageTypes: config.percentageTypes,
				projectMapConfig: config.projectMapConfig,
				projectNotifications: config.projectNotifications,
				projectSpecificTagFormat: config.projectSpecificTagFormat,
				queryBuilderSupported: config.queryBuilderSupported || false,
				relevancySlider: config.relevancySlider,
				showAllTopicsMap: config.showAllTopicsMap,
				showTopicsInGraph: config.showTopicsInGraph,
				explorerDatasets: config.explorerDatasets,
				explorerShowEntities: config.explorerShowEntities,
				statsPDF: config.statsPDF,
				timezone: config.timezone,
				topPhrasesAvailable: config.topPhrasesAvailable,
				topicsPie: config.topicsPie,
				topicsPieArray: config.topicsPieArray,
				topicStatsConfig: config.topicStatsConfig,
				translateArticleTitles: config.translateArticleTitles,
				uiThemeToggle: config.uiThemeToggle,
				useGlobalMaps: config.useGlobalMaps,
				useInternalTranslation: config.useInternalTranslation,
				videoTabEntities: config.videoTabEntities,
				videoTabEntityGraph: config.videoTabEntityGraph,
				videoTabEndDate: config.videoTabEndDate,
				videoTabStartDate: config.videoTabStartDate,
				videoTabTopics: config.videoTabTopics,
				webPagesCollections: config.webPagesCollections,
			});
		}
	};
};

// Set projectConfig variables in lazy loaded reducers
export const configLazyReducers = () => {
	return (dispatch, getState) => {
		const {
			defaultAggregationLevel,
			defaultSearchTranslationEnabled,
			defaultSearchTranslationLanguages,
			contentHeaderSortAudienceDefault,
			contentHeaderSortSourceDefault,
			contentTabDateBegin,
			contentTabDateEnd,
			crosstabsNarrativeFacets,
			dmaMap,
			entityLanguage,
			explorerDatasets,
			mediaLanguages,
			mediaCountries,
			videoTabEndDate,
			videoTabStartDate,
		} = getState().projectConfig;
		// const { currentProject } = getState().login;

		dispatch({
			type: CONFIG_LAZY_REDUCERS,
			contentHeaderSortAudienceDefault,
			contentHeaderSortSourceDefault,
			contentTabDateBegin,
			contentTabDateEnd,
			crosstabsNarrativeFacets,
			defaultAggregationLevel,
			defaultSearchTranslationEnabled,
			defaultSearchTranslationLanguages,
			dmaMap,
			entityLanguage,
			explorerDatasets,
			mediaLanguages,
			mediaCountries,
			videoTabEndDate,
			videoTabStartDate,
		});
	};
};
